import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle } from 'lucide-react';
const testimonials = [{
  name: 'Laura M.',
  text: "I noticed it on Day 3. The background tension dropped. I could think again. It wasn't magic, it was just... relief.",
  textJsx: <>
        I noticed it on{' '}
        <span className="font-semibold text-[#4338CA]" data-id="element-303">Day 3</span>. The
        background tension{' '}
        <span className="bg-[#FDE68A]/50 px-0.5 rounded font-semibold text-[#1E1B4B]" data-id="element-304">
          dropped
        </span>
        . I could think again. It wasn't magic, it was just... relief.
      </>,
  highlight: 'Tension dropped'
}, {
  name: 'Daniel R.',
  text: "I didn't need motivation. I followed the steps. My sleep improved by Day 5. Simple as that.",
  textJsx: <>
        I didn't need motivation. I followed the steps. My{' '}
        <span className="bg-[#FDE68A]/50 px-0.5 rounded font-semibold text-[#1E1B4B]" data-id="element-305">
          sleep improved
        </span>{' '}
        by <span className="font-semibold text-[#4338CA]" data-id="element-306">Day 5</span>. Simple
        as that.
      </>,
  highlight: 'Better sleep'
}, {
  name: 'Ana C.',
  text: "I've done therapy worksheets. This felt like a system for my body, not a lecture. Finally something practical.",
  textJsx: <>
        I've done therapy worksheets. This felt like a{' '}
        <span className="bg-[#FDE68A]/50 px-0.5 rounded font-semibold text-[#1E1B4B]" data-id="element-307">
          system for my body
        </span>
        , not a lecture. Finally something practical.
      </>,
  highlight: 'Practical system'
}, {
  name: 'Marcus T.',
  text: 'The breathing protocol on Day 1 is my go-to now. Whenever I feel the chest tightness, I know exactly what to do.',
  textJsx: <>
        The breathing protocol on{' '}
        <span className="font-semibold text-[#4338CA]" data-id="element-308">Day 1</span> is my go-to
        now. Whenever I feel the chest tightness,{' '}
        <span className="bg-[#FDE68A]/50 px-0.5 rounded font-semibold text-[#1E1B4B]" data-id="element-309">
          I know exactly what to do.
        </span>
      </>,
  highlight: 'Actionable tools'
}, {
  name: 'Sarah J.',
  text: 'I was skeptical because I\'ve tried everything. But the "Stimulation Diet" concept changed how I view my evenings.',
  textJsx: <>
        I was skeptical because I've tried everything. But the{' '}
        <span className="font-semibold text-[#4338CA]" data-id="element-310">"Stimulation Diet"</span>{' '}
        concept{' '}
        <span className="bg-[#FDE68A]/50 px-0.5 rounded font-semibold text-[#1E1B4B]" data-id="element-311">
          changed how I view my evenings.
        </span>
      </>,
  highlight: 'New perspective'
}, {
  name: 'David K.',
  text: "Worth every penny. It's short, to the point, and actually helps you calm down in the moment.",
  textJsx: <>
        <span className="font-semibold text-[#1E1B4B]" data-id="element-312">Worth every penny.</span>{' '}
        It's short, to the point, and actually helps you{' '}
        <span className="bg-[#FDE68A]/50 px-0.5 rounded font-semibold text-[#1E1B4B]" data-id="element-313">
          calm down in the moment.
        </span>
      </>,
  highlight: 'To the point'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-[#FAFAFF] relative overflow-hidden" data-id="element-314">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-315">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14 relative" data-id="element-316">
          <div className="absolute inset-0 -inset-x-8 -inset-y-6 bg-gradient-to-b from-[#EEF2FF] to-transparent rounded-3xl -z-10" data-id="element-317" />
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#EEF2FF] text-[#4338CA] text-sm font-semibold mb-4" data-id="element-318">
            <Star className="w-4 h-4 fill-current" data-id="element-319" />
            Real Results
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1E1B4B] mb-4" data-id="element-320">
            "Regulation you can feel."
          </h2>
          <p className="text-[#44403C] max-w-lg mx-auto" data-id="element-321">
            See what happens when you stop fighting anxiety and start regulating
            it.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-322">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl p-6 shadow-sm border border-[#E0E7FF] relative" data-id="element-323">
              <div className="flex gap-1 mb-4" data-id="element-324">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-[#818CF8] fill-current" data-id="element-325" />)}
              </div>
              <p className="text-[#44403C] text-sm leading-relaxed mb-4 italic" data-id="element-326">
                "{testimonial.textJsx}"
              </p>
              <div className="flex items-center justify-between mt-auto pt-4 border-t border-[#F5F5FA]" data-id="element-327">
                <div className="flex items-center gap-2" data-id="element-328">
                  <div className="w-8 h-8 bg-[#EEF2FF] rounded-full flex items-center justify-center text-[#4338CA] font-bold text-xs" data-id="element-329">
                    {testimonial.name.charAt(0)}
                  </div>
                  <span className="font-bold text-[#1E1B4B] text-sm" data-id="element-330">
                    {testimonial.name}
                  </span>
                </div>
                <div className="flex items-center text-xs text-[#4338CA] font-medium" data-id="element-331">
                  <CheckCircle className="w-3 h-3 mr-1" data-id="element-332" />
                  {testimonial.highlight}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}